import { Api } from '../../common/api/const';
import { School } from '../model/school';

export class SchoolsApiService {
    static fetchSchools = () => Api().get(`/schools`);
    static postSchool = (school: School) => Api().post(`/schools`, school);
    static putSchool = (school: School) => Api().put(`/schools/${school?.id}`, school);
    static replace = (o: string, n: string) => Api().post(`/schools/${o}/to/${n}`)
}